import React from 'react';

import Layout from '../../components/Layout';
import Header from '../../components/Header';
import Navigation from '../../components/Navigation';
import { CustomersPageContent } from '../../components/Customers';

const CustomersListPage = () => {
  return (
    <Layout>
      <Layout.TopBar>
        <Header />
      </Layout.TopBar>
      <Layout.Body>
        <Layout.SideBar>
          <Navigation />
        </Layout.SideBar>
        <Layout.Content>
          <CustomersPageContent />
        </Layout.Content>
      </Layout.Body>
    </Layout>
  );
};

export default CustomersListPage;
